const mission = {
    sub: "Our Mission",
    heading: "Transforming Businesses with AI Innovation",
    content: "At AI Innovate, our mission is to empower businesses with cutting-edge AI solutions. By integrating smart technology into your workflows, we help streamline processes, enhance decision-making, and drive exponential growth.",
    points: [
        {
            id: 1,
            title: 'AI Precision',
            progress: 98,
        },
        {
            id: 2,
            title: 'Scalability',
            progress: 95,
        },
        {
            id: 3,
            title: 'Custom Solutions',
            progress: 92,
        },
        {
            id: 4,
            title: 'User Satisfaction',
            progress: 99,
        },
    ]
};

export default mission;